import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export function MonitorLiner24(param) {
    let { color = 'currentColor' } = param;
    return /*#__PURE__*/ _jsxs("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6.90337 2.83334H17.0875C20.3509 2.83334 21.1667 3.64918 21.1667 6.90334V12.7058C21.1667 15.9692 20.3509 16.7758 17.0967 16.7758H6.90337C3.64921 16.785 2.83337 15.9692 2.83337 12.715V6.90334C2.83337 3.64918 3.64921 2.83334 6.90337 2.83334Z",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M12 16.785V21.1667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.83337 12.9167H21.1667",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.875 21.1667H16.125",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
